// /brokers/provider-cases — the provider-operation recovery queue (SM-661,
// SM-621 phase 14). The default view is what needs a human (OPEN cases);
// the state filter widens it to history. Filters and the page live in the
// URL so a triage view is shareable.
//
// An index route, not brokers.provider-cases.tsx: that file would be the
// LAYOUT of the case detail below, and its search params would leak into
// it. The route is /brokers/…, deliberately NOT under /admin: the dev
// server proxies the /admin prefix to the API.
//
// Gated on BROKER_PROVIDER_CASE_VIEW (useMyPerms() inside the page — it
// requests nothing without it). See components/brokers/ProviderRecoveryCases.
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import {
  RECOVERY_ANY_STATE,
  RecoveryCaseList,
  type RecoveryCaseSearch,
} from "@/components/brokers/ProviderRecoveryCases";
import { RECOVERY_CASE_KINDS, RECOVERY_CASE_SEVERITIES } from "@/lib/broker-types";

const pick = <T extends string>(v: unknown, allowed: readonly T[]): T | undefined =>
  allowed.find((a) => a === v);

export const Route = createFileRoute("/_app/brokers/provider-cases/")({
  validateSearch: (s: Record<string, unknown>): RecoveryCaseSearch => ({
    state: pick(s.state, ["RESOLVED", RECOVERY_ANY_STATE] as const),
    severity: pick(s.severity, RECOVERY_CASE_SEVERITIES),
    kind: pick(s.kind, RECOVERY_CASE_KINDS),
    page: Number.isFinite(Number(s.page)) && Number(s.page) > 0 ? Number(s.page) : undefined,
  }),
  component: ProviderRecoveryCasesPage,
});

function ProviderRecoveryCasesPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <RecoveryCaseList
      search={search}
      onSearch={(next) => void navigate({ search: (s) => ({ ...s, ...next }) })}
      onOpen={(caseId) => void navigate({ to: "/brokers/provider-cases/$caseId", params: { caseId } })}
    />
  );
}
